"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.certificatesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const DictionaryEvidence = __importStar(require("../../composite/evidence/dictionary-evidence/dictionary-evidence"));
const evidence_1 = require("../../composite/evidence/evidence");
const empty_component_1 = require("../../utils/empty-component");
const certificates_fields_1 = require("./certificates-fields");
const certificates_schema_1 = require("./certificates-schema");
function certificatesFactory({ url, exportTag, defaultSorts, }) {
    return function Actions() {
        const intl = (0, react_intl_1.useIntl)();
        const validationSchema = (0, certificates_schema_1.useValidationSchema)();
        const evidence = DictionaryEvidence.useDictionaryEvidence({
            identifier: 'CERTIFICATES',
            apiProps: {
                url,
            },
            tableProps: {
                tableName: intl.formatMessage({
                    id: 'EAS_CERTIFICATES_TABLE_TITLE',
                    defaultMessage: 'Certifikáty',
                }),
                reportTag: exportTag,
                defaultSorts,
            },
            detailProps: {
                GeneralFieldsComponent: empty_component_1.EmptyComponent,
                FieldsComponent: certificates_fields_1.CertificateFields,
                validationSchema,
                toolbarProps: {
                    title: intl.formatMessage({
                        id: 'EAS_CERTIFICATES_DETAIL_TITLE',
                        defaultMessage: 'Certifikát',
                    }),
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, { ...evidence });
    };
}
exports.certificatesFactory = certificatesFactory;
//# sourceMappingURL=certificates.js.map